(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-utils/jupiter-helper/assets/prescript.js') >= 0) return;  svs.modules.push('/components/tb-utils/jupiter-helper/assets/prescript.js');
'use strict';

svs.components = svs.components || {};
svs.components.tbUtils = svs.components.tbUtils || {};
svs.components.tbUtils.jupiterHelper = svs.components.tbUtils.jupiterHelper || {};
svs.components.tbUtils.jupiterHelper.logger = new svs.core.log.Logger('component:jupiter-helper');

 })(window);